import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';

@Injectable({
  providedIn: 'root'
})
export class PlantViewService extends AbstractRestService {
  postInit(): void {}

  getPlantData(CurrentShift: string = "True", StartDate: string = "", EndDate: string = "", plant: string = "") :Observable<GenericLambdaReturn<PlantType[]>> {
    let params:any={
      "CurrentShift": CurrentShift,
      "StartDate": StartDate,
      "EndDate": EndDate,
      "Site": plant
    };

    return this.get({
      ApiResource: '/plant',
      data: params
    });
  }

}

export type PlantType = {
  site: string;
  Line: string;
  Critical: number;
  Major: number;
  Minor: number;
  None: number;
  Total: number;
  acknowledged : number;
  Score: number;
}